'use strict';

module.exports = require('./matrix').Matrix;
module.exports.Decompositions = module.exports.DC = require('./decompositions');
